import React, { useState, useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import styled from "styled-components";

import { colorPalette } from "./Config/colorConfig.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

import { CloseButton } from "./Config/generalButton.js";

import {
  logo,
  questionIcon,
  newsIcon,
  controlGuideIcon,
  homeIcon,
  emoLogo,
  timtosLogo,
  controlGuide_ch,
  controlGuide_en,
  controlGuidePhone_ch,
  controlGuidePhone_en,
  emoBg,
  timtosBg,
} from "./Config/imgIconConfig.js";

import { emoConfig } from "./Config/emoConfig.js";
import { timtosConfig } from "./Config/timtosConfig.js";

import PanoScene from "./components/Panoscene";
import NaviSlide from "./components/NaviSlide";
import Card from "./components/Card/Card";
import { MapOverview, MapPlan } from "./components/Maps";

//cursor:'pointer' for ios device

const Wrapper = styled.div`
  cursor: "pointer";
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0px;
`;

const PanoSceneWrapper = styled(animated.div)`
  position absolute;
  z-index:0;
`;

const Opening = styled(animated.div)`
  position: absolute;
  width: 100vw;
  height: 100vh;
  margin: 0px;
  overflow: hidden;
  background-color: ${colorPalette.myGrey};
  z-index: 999;
`;

const Logo = styled.img`
  position: relative;
  width: 350px;
  left: calc(50% - 175px);
  top: calc(40% - 90px);
  @media (max-width: 768px) {
    width: 50%;
    top: 40%;
    left: 25%;
  }
  margin: none;
  border: none;
  z-index: 310;
`;

const RecButton = styled.button`
  cursor: "pointer";
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  height: 35px;
  color: #fff;
  background-color: rgba(197, 197, 197, 0.7);
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 2px;
  border: 1px solid ${colorPalette.myBlue};
  border-radius: 5px;
  padding: 0px 6px;
  z-index: 50;
  &:hover {
    border: 1px solid #fff;
    background-color: ${colorPalette.myBlue};
  }
  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`;

const CircleButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 35px;
  height: 35px;
  background-color: rgba(197, 197, 197, 0.7);
  border: 1px solid ${colorPalette.myBlue};
  border-radius: 50%;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  z-index: 50;
  &:hover {
    background-color: ${colorPalette.myBlue};
    transform: scale(1.1);
  }
  &:active,
  &:visited,
  &:focus {
    outline: none;
  }
`;

const Icon = styled.img`
  cursor: "pointer";
  position: relative;
  width: 2rem;
  height: auto;
  border: none;
`;

const ControlGuideWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 500;
`;

const ControlGuideImg = styled.img`
  position: relative;
  width: 80%;
  height: auto;
  left: 10%;
  top: 0px;
`;

const EmoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 350;
`;

const EmoBg = styled.div`
  position: absolute;
  width: 80vw;
  height: 45vw;
  left: 10%;
  top: 5%;
  background-size: 100% 100%;
  @media (max-width: 768px) {
    width: 100vw;
    height: 56.3vw;
    top: 20%;
    left: 0%;
  }
`;

const EmoBtn = styled.img`
  position: absolute;
  height: 5%;
  min-height: 10px;
  width: auto;
  transform-origin: 50% 50%;
  &:hover {
    transform: scale(1.3, 1.3);
  }
`;

let mobile;
if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
) {
  //console.log('mobile')
  mobile = true;
} else {
  //console.log('not mobile')
  mobile = false;
}

function App({ lang, isEmo, isTimtos }) {
  const [isMobile] = useState(mobile);
  mobile = null;

  const [ABShift, setABShift] = useState(false); //true=>A;false=>B

  const [imgIndex, setImgIndex] = useState(0);
  const [imgAIndex, setImgAIndex] = useState(0);
  const [imgBIndex, setImgBIndex] = useState(0);

  const [nowYaw, setNowYaw] = useState(0); //for map marker

  const [goToYaw, setGoToYaw] = useState(0);
  const [goToYawA, setGoToYawA] = useState(0);
  const [goToYawB, setGoToYawB] = useState(0);

  const [goToPitch, setGoToPitch] = useState(0);
  const [goToPitchA, setGoToPitchA] = useState(0);
  const [goToPitchB, setGoToPitchB] = useState(0);

  const [naviSlideHide, setNaviSlideHide] = useState(false);

  const [overviewMode, setOverviewMode] = useState(false);
  const [planMode, setPlanMode] = useState(""); // '', med, large

  const [lookAtCard, setLookAtCard] = useState(false);
  const [cardType, setCardType] = useState("");
  const [cardContent, setCardContent] = useState("");

  const [panoLoad, setPanoLoad] = useState(false); //for opening
  const [opening, setOpening] = useState(true);

  const [langCh, setLangCh] = useState(lang);
  const [newsEvents, setNewsEvents] = useState(false);
  const [controlGuide, setControlGuide] = useState(false);

  const [timtos, setTimtos] = useState(isTimtos);
  const [emo, setEmo] = useState(isEmo);

  const panoA = useRef(null);
  const panoB = useRef(null);

  const naviRef = useRef(null);

  const openingProps = useSpring({
    opacity: opening ? 1 : 0,
    config: { duration: 300 },
  });
  const panoSceneAWrapperProps = useSpring({
    opacity: ABShift ? 1 : 0,
    config: { duration: 250 },
  });
  const panoSceneBWrapperProps = useSpring({
    opacity: ABShift ? 0 : 1,
    config: { duration: 250 },
  });

  const hotSpotsClickHandler = (type, args, card) => {
    //console.log(type, args,machine)
    switch (type) {
      case "GOTO":
        setGoToYaw(args[1]);
        setGoToPitch(args[2]);
        setImgIndex(args[0]);
        break;
      case "LOOKAT":
        if (!ABShift) {
          panoA.current.getViewer().lookAt(...args);
        } else {
          panoB.current.getViewer().lookAt(...args);
        }
        setCardType(card[0]);
        setCardContent(card[1]);
        setLookAtCard((c) => !c);
        break;
      default:
        break;
    }
  };

  let OpeningClose = () =>
    setTimeout(() => {
      setOpening(false);
    }, 250);
  useEffect(() => {
    if (panoLoad) {
      OpeningClose();
    }
    clearTimeout(OpeningClose);
  }, [panoLoad]);

  useEffect(() => {
    if (!ABShift) {
      setGoToYawB(goToYaw);
      setGoToPitchB(goToPitch);
    } else {
      setGoToYawA(goToYaw);
      setGoToPitchA(goToPitch);
    }
  }, [ABShift, goToYaw, goToPitch]);

  useEffect(() => {
    if (ABShift) {
      imgIndex === imgBIndex ? setABShift((c) => !c) : setImgBIndex(imgIndex);
    } else {
      imgIndex === imgAIndex ? setABShift((c) => !c) : setImgAIndex(imgIndex);
    }
  }, [imgIndex]);

  //console.log(ABShift)
  //console.log(imgIndex)
  //console.log(window.innerWidth)

  return (
    <Wrapper>
      <Opening
        style={{
          ...openingProps,
          visibility: openingProps.opacity.interpolate((o) =>
            o === 0 ? "hidden" : "visible"
          ),
        }}
      >
        <Logo src={logo} />
      </Opening>

      {lookAtCard && (
        <Card
          isMobile={isMobile}
          setLookAtCard={setLookAtCard}
          cardType={cardType}
          cardContent={cardContent}
          setCardContent={setCardContent}
          langCh={langCh}
        />
      )}

      {/*left side button*/}

      <RecButton
        style={{
          top: "2%",
          left: "1%",
          backgroundColor:
            overviewMode === true ? `${colorPalette.myBlue}` : null,
        }}
        onClick={() => {
          setOverviewMode((c) => !c);
          setPlanMode("");
        }}
      >
        <FontAwesomeIcon
          icon={faMapMarkerAlt}
          size="lg"
          style={{ padding: "0px 6px 0px 0px" }}
        />
        {langCh ? "全景導覽地圖" : "Showroom Aerial View"}
      </RecButton>

      <RecButton
        style={{
          top: "calc(2% + 50px)",
          left: "1%",
          backgroundColor: planMode !== "" ? `${colorPalette.myBlue}` : null,
        }}
        onClick={() => {
          planMode !== "" ? setPlanMode("") : setPlanMode("med");
          setOverviewMode(false);
        }}
      >
        <FontAwesomeIcon
          icon={faMapMarkerAlt}
          size="lg"
          style={{ padding: "0px 6px 0px 0px" }}
        />
        {langCh ? "您目前的位置" : "\xa0My Current Location\xa0\xa0"}
      </RecButton>

      <CircleButton
        style={{ top: "calc(2% + 100px)", left: "1%" }}
        onClick={() => {
          setGoToYaw(0);
          setGoToPitch(0);
          setImgIndex(0);
        }}
      >
        <Icon src={homeIcon} />
      </CircleButton>

      {/*right side button*/}
      <CircleButton
        style={{
          position: "fixed",
          bottom: naviSlideHide ? "170px" : !isMobile ? "290px" : "260px",
          right: "1%",
        }}
        onClick={(e) => {
          e.preventDefault();
          window.open(
            langCh
              ? "https://www.ycmcnc.com/contact"
              : "https://www.ycmcnc.com/en/contact",
            "_blank"
          );
        }}
      >
        <Icon src={questionIcon} />
      </CircleButton>

      <CircleButton
        style={{
          position: "fixed",
          bottom: naviSlideHide ? "120px" : !isMobile ? "240px" : "210px",
          right: "1%",
        }}
        onClick={() => setLangCh((c) => !c)}
      >
        {langCh ? "EN" : "中"}
      </CircleButton>

      {(newsEvents || timtos) && (
        <RecButton
          style={{
            position: "fixed",
            height: "30px",
            width: "150px",
            bottom: naviSlideHide ? "180px" : !isMobile ? "300px" : "270px",
            right: "calc( 2% + 35px)",
            backgroundColor: timtos ? `${colorPalette.myBlue}` : null,
            zIndex: timtos ? "300" : "50",
          }}
          onClick={() => {
            setTimtos((c) => !c);
          }}
        >
          <Icon
            src={timtosLogo}
            style={{ padding: "0px 6px 0px 6px", width: "9rem" }}
          />
        </RecButton>
      )}

      {(newsEvents || emo) && (
        <RecButton
          style={{
            position: "fixed",
            height: "50px",
            width: "70px",
            bottom: naviSlideHide ? "120px" : !isMobile ? "240px" : "210px",
            right: "calc( 2% + 35px)",
            backgroundColor: emo ? `${colorPalette.myBlue}` : null,
            zIndex: emo ? "300" : "50",
          }}
          onClick={() => {
            setEmo((c) => !c);
          }}
        >
          <Icon
            src={emoLogo}
            style={{ padding: "0px 6px 0px 6px", width: "3.5rem" }}
          />
        </RecButton>
      )}

      <RecButton
        style={{
          position: "fixed",
          bottom: naviSlideHide ? "70px" : !isMobile ? "190px" : "160px",
          right: "1%",
          backgroundColor: newsEvents ? `${colorPalette.myBlue}` : null,
          zIndex: "50",
        }}
        onClick={() => {
          setNewsEvents((c) => !c);
        }}
      >
        <Icon src={newsIcon} style={{ padding: "0px 6px 0px 0px" }} />
        {langCh ? "最新消息" : "News & Events"}
      </RecButton>

      <RecButton
        style={{
          position: "fixed",
          bottom: naviSlideHide ? "20px" : !isMobile ? "140px" : "110px",
          right: "1%",
          backgroundColor: controlGuide ? `${colorPalette.myBlue}` : null,
          zIndex: controlGuide ? "600" : "50",
        }}
        onClick={() => {
          setControlGuide((c) => !c);
        }}
      >
        <Icon src={controlGuideIcon} style={{ padding: "0px 6px 0px 0px" }} />
        {langCh ? "操作說明" : "User Guide"}
      </RecButton>

      {controlGuide && (
        <ControlGuideWrapper>
          <ControlGuideImg
            src={
              window.innerWidth > 768
                ? langCh
                  ? controlGuide_ch
                  : controlGuide_en
                : langCh
                ? controlGuidePhone_ch
                : controlGuidePhone_en
            }
          />
        </ControlGuideWrapper>
      )}

      {timtos && (
        <EmoWrapper>
          <EmoBg style={{ backgroundImage: `url(${timtosBg})` }}>
            <CloseButton
              style={{ position: "absolute" }}
              handler={() => setTimtos(false)}
            />
            {timtosConfig.map((data, i) => (
              <EmoBtn
                key={i}
                src={data.src}
                style={{
                  top: data.top,
                  left: data.left,
                  height: i === 6 ? "15%" : "5%",
                }}
                onClick={(e) => {
                  if (i !== 6 && i !== 2 && i !== 5) {
                    setCardType(data.card[0]);
                    setCardContent(data.card[1]);
                    setLookAtCard((c) => !c);
                  }
                  if (i === 6) {
                    e.preventDefault();
                    if (langCh){
                      window.open("https://www.youtube.com/watch?v=lmQ6J3XQ-e0&t=26s", "_blank");
                    }
                    else{
                      window.open("https://www.youtube.com/watch?v=ni-XWvd-FuQ", "_blank");
                    }
                  }
                  if (i === 2) {
                    e.preventDefault();
                    if (langCh){
                      window.open("https://www.ycmcnc.com/new/1533009146757/1645152207894", "_blank");
                    }
                    else{
                      window.open("https://www.ycmcnc.com/en/new/1533009146757/1645152207894", "_blank");
                    }
                  }
                  if (i === 5) {
                    e.preventDefault();
                    if (langCh){
                      window.open("https://youtu.be/xqU-vpnxQuQ", "_blank");
                    }
                    else{
                      window.open("https://www.youtube.com/watch?v=6kECQZAvp_w", "_blank");
                    }
                  }
                }}
              />
            ))}
          </EmoBg>
        </EmoWrapper>
      )}

      {emo && (
        <EmoWrapper>
          <EmoBg style={{ backgroundImage: `url(${emoBg})` }}>
            <CloseButton
              style={{ position: "absolute" }}
              handler={() => setEmo(false)}
            />
            {emoConfig.map((data, i) => (
              <EmoBtn
                key={i}
                src={data.src}
                style={{
                  top: data.top,
                  left: data.left,
                  height: i === 7 ? "15%" : "5%",
                }}
                onClick={(e) => {
                  if (i !== 7 && i !== 3) {
                    setCardType(data.card[0]);
                    setCardContent(data.card[1]);
                    setLookAtCard((c) => !c);
                  }
                  if (i === 7) {
                    e.preventDefault();
                    window.open("https://www.youtube.com/watch?v=DiaYQoJ5Yig", "_blank");
                  }
                  if (i === 3) {
                    setGoToYaw(0);
                    setGoToPitch(0);
                    setImgIndex(0);
                    setEmo(false);
                  }
                }}
              />
            ))}
          </EmoBg>
        </EmoWrapper>
      )}

      {overviewMode && (
        <MapOverview
          overviewMode={overviewMode}
          setOverviewMode={setOverviewMode}
          setImgIndex={setImgIndex}
          setGoToYaw={setGoToYaw}
          setGoToPitch={setGoToPitch}
          langCh={langCh}
        />
      )}
      {planMode && (
        <MapPlan
          planMode={planMode}
          setPlanMode={setPlanMode}
          imgIndex={imgIndex}
          setImgIndex={setImgIndex}
          setGoToYaw={setGoToYaw}
          setGoToPitch={setGoToPitch}
          nowYaw={nowYaw}
          langCh={langCh}
        />
      )}

      {/*Scene A*/}
      <PanoSceneWrapper
        style={{
          ...panoSceneAWrapperProps,
          visibility: panoSceneAWrapperProps.opacity.interpolate((o) =>
            o === 0 ? "hidden" : "visible"
          ),
          zIndex: panoSceneAWrapperProps.opacity.interpolate((o) =>
            o === 0 ? 0 : 10
          ), //important!
        }}
      >
        <PanoScene
          isMobile={isMobile}
          pano={panoA}
          imgIndex={imgAIndex}
          panoLoad={panoLoad}
          setPanoLoad={setPanoLoad}
          goToYaw={goToYawA}
          goToPitch={goToPitchA}
          setLookAtCard={setLookAtCard}
          planMode={planMode}
          setPlanMode={setPlanMode}
          setNowYaw={setNowYaw}
          hotSpotsClickHandler={hotSpotsClickHandler}
          setABShift={setABShift}
        />
      </PanoSceneWrapper>
      {/*Scene B*/}
      <PanoSceneWrapper
        style={{
          ...panoSceneBWrapperProps,
          visibility: panoSceneBWrapperProps.opacity.interpolate((o) =>
            o === 0 ? "hidden" : "visible"
          ),
          zIndex: panoSceneBWrapperProps.opacity.interpolate((o) =>
            o === 0 ? 0 : 10
          ), //important!
        }}
      >
        <PanoScene
          isMobile={isMobile}
          pano={panoB}
          imgIndex={imgBIndex}
          panoLoad={panoLoad}
          setPanoLoad={setPanoLoad}
          goToYaw={goToYawB}
          goToPitch={goToPitchB}
          setLookAtCard={setLookAtCard}
          planMode={planMode}
          setPlanMode={setPlanMode}
          setNowYaw={setNowYaw}
          hotSpotsClickHandler={hotSpotsClickHandler}
          setABShift={setABShift}
        />
      </PanoSceneWrapper>

      <NaviSlide
        naviRef={naviRef}
        naviSlideHide={naviSlideHide}
        setNaviSlideHide={setNaviSlideHide}
        setImgIndex={setImgIndex}
        setGoToYaw={setGoToYaw}
        setGoToPitch={setGoToPitch}
        setLookAtCard={setLookAtCard}
        langCh={langCh}
      />
    </Wrapper>
  );
}

export default App;
